import { isThisYear } from 'date-fns';

import { PayloadAction } from '../../../../../store.model';
import { dateTransformRows } from '../function/date-transform-rows.function';
import { determinePeriod } from '../function/determine-period.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../main.action';
import { defaultState, MainState } from '../main.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: MainState,
    action: PayloadAction<ActionType.WP_MAIN__RELOAD, Reload>,
): MainState {
    const nextState: MainState = {
        ...defaultState(),
        pending: {
            ...state.pending,
            reload: true,
        },
    };
    if (action.payload.reset === true) {
        nextState.pending.reset = true;
        nextState.dataRanges = state.dataRanges;
        nextState.selectedDataRange = state.selectedDataRange;
        nextState.selectedEvalRange = state.selectedEvalRange;
        nextState.drillPaths = state.drillPaths;
        nextState.selectedDrillPathId = state.selectedDrillPathId;
    }
    return nextState;
}

export function reloadResultReducer(
    state: MainState,
    action: PayloadAction<ActionType.WP_MAIN__RELOAD_RESULT, ReloadResult>,
): MainState {
    try {
        const nextRows = sortRows(
            action.payload.table?.rows,
            state.sortOptions,
            action.payload.table,
            action.payload.config,
        );

        action.payload.config.dataRanges.forEach((dr) => {
            dr.evaluationRanges.forEach((er) => {
                er.startDateDataRange =
                    er?.startDateDataRange == null
                        ? null
                        : new Date(er.startDateDataRange);

                er.endDateDataRange =
                    er?.endDateDataRange == null
                        ? null
                        : new Date(er.endDateDataRange);

                /* TODO revise. just always use 'LLLL y' regardless of year */
                if (
                    !isThisYear(er.endDateDataRange) &&
                    er.labelFormat?.startsWith('date:') === true
                ) {
                    er.labelFormat = `${er.labelFormat} y`;
                }
            });
        });

        dateTransformRows(nextRows);

        const nextSelectedDataRange =
            action.payload.config.dataRanges.find(
                (e) =>
                    action.payload.dataRangeId != null &&
                    e.dataRangeId === action.payload.dataRangeId,
            ) ?? action.payload.config.dataRanges.find((e) => e.isDefault);

        const nextSelectedEvalRange =
            nextSelectedDataRange?.evaluationRanges?.find(
                (e) =>
                    action.payload.evalRangeId != null &&
                    e.evaluationRangeIsOaMetricId ===
                        action.payload.evalRangeId,
            ) ??
            nextSelectedDataRange?.evaluationRanges?.find((e) => e.isDefault);

        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
                reset: undefined,
            },
            config: action.payload.config,
            table: action.payload.table,
            dataRanges: action.payload.config.dataRanges,
            selectedDataRange: nextSelectedDataRange,
            selectedEvalRange: nextSelectedEvalRange,
            drillPaths: action.payload.config.drillPaths,
            selectedDrillPathId:
                action.payload.drillPathId ??
                action.payload.config.drillPaths.find((e) => e.isDefault)
                    .identifier,
            period: determinePeriod(action.payload.table),
            hasData: nextRows?.length > 0,
            rows: nextRows,
        };
    } catch (err) {
        console.log(err);

        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
                reset: undefined,
            },
        };
    }
}
